import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsOverview = ({ metrics }) => {
  const metricCards = [
    {
      title: 'Active Campaigns',
      value: metrics?.activeCampaigns,
      change: '+12%',
      trend: 'up',
      icon: 'Zap',
      color: 'primary',
      description: 'Currently running'
    },
    {
      title: 'Total Influencers',
      value: metrics?.totalInfluencers?.toLocaleString(),
      change: '+24%',
      trend: 'up',
      icon: 'Users',
      color: 'secondary',
      description: 'Engaged participants'
    },
    {
      title: 'Avg Engagement',
      value: `${metrics?.avgEngagement}%`,
      change: '+8%',
      trend: 'up',
      icon: 'TrendingUp',
      color: 'success',
      description: 'Across all campaigns'
    },
    {
      title: 'Total Budget',
      value: `$${metrics?.totalBudget?.toLocaleString()}`,
      change: '-5%',
      trend: 'down',
      icon: 'DollarSign',
      color: 'accent',
      description: 'Allocated funds'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-4 md:p-6 border border-border hover:shadow-lg transition-all duration-250"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-${metric?.color}/10`}>
              <Icon name={metric?.icon} size={24} className={`text-${metric?.color}`} />
            </div>
            <span className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${
              metric?.trend === 'up' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
            }`}>
              <Icon name={metric?.trend === 'up' ? 'ArrowUp' : 'ArrowDown'} size={12} />
              {metric?.change}
            </span>
          </div>
          <h3 className="text-sm text-muted-foreground mb-1">{metric?.title}</h3>
          <p className="text-2xl md:text-3xl font-bold text-foreground mb-1 data-text">
            {metric?.value}
          </p>
          <p className="text-xs text-muted-foreground">{metric?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;